export default function (action) {
    return `/wp/wp-admin/admin-ajax.php?action=${action}`;
}



// WEBPACK FOOTER //
// ./scripts/util/actionAjaxUrl.js